export default function ({ language }) {
  var config = {
    label: language['name-label'],
    autoComplete: 'name',
    placeholder: language['name-placeholder'],
    validators: ['mandatory', 'minChars:2', 'notNumbers'],
  };

  return {
    config,
    extendsType: 'text-field',
  };
}
